import React from 'react'
import './COQ4.css'
import EnterButton from '../../Components/EnterButton/EnterButton'
import TitleSection from '../../Components/TitleSection/TitleSection'
import ChoiceTile from '../../Components/ChoiceTile/ChoiceTile'
import { CSSTransition } from 'react-transition-group'
import Navigation from '../../Components/Navigation/Navigation'

export default class COQ4 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      name: '',
      email: '',
      committees: '',
      dutch: false,
      english: false,
    }
  }

  componentDidMount() {
    if (
      !this.props.location.state ||
      !this.props.location.state.name ||
      !this.props.location.state.email
    ) {
      this.props.history.push('/')
      return
    } else {
      this.setState({
        name: this.props.location.state.name,
        email: this.props.location.state.email,
        committees: this.props.location.state.committees,
      })
    }
    document.addEventListener('keydown', this.handleKeyDown)
    this.setState({ show: true })
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.executeNextStep()
    }
  }
  toggleOptionOne = () => {
    this.setState({ dutch: !this.state.dutch })
  }
  toggleOptionTwo = () => {
    this.setState({ english: !this.state.english })
  }

  executeNextStep = () => {
    if (!(this.state.dutch || this.state.english)) {
      alert(
        'Please choose one of the options. Or go back to change your selection.',
      )
    } else {
      this.setState({ show: false })
      var committees = this.state.committees
      committees.q4 = {
        dutch: this.state.dutch,
        english: this.state.english,
      }
      setTimeout(() => {
        this.props.history.push('/careeropportunities/COLoading', {
          name: this.state.name,
          email: this.state.email,
          committees: committees,
        })
      }, 500)
    }
  }

  render() {
    return (
      <div className="mainWrapper">
          <CSSTransition
            classNames="fadeIn"
            in={this.state.show}
            unmountOnExit
            timeout={20000}
          >
            <div className="essentialWrapper">
              <div className="contentWrapperRow">
                <div>
                  <div>
                    <TitleSection
                      subtitle="Matching"
                      title="Which languages do you master? (one or more)"
                    />
                  </div>
                  <div className="choicesWrapper">
                    <ChoiceTile
                      clicked={this.state.dutch}
                      onClick={this.toggleOptionOne}
                      title="Dutch"
                      key={"Dutch"+this.state.dutch}
                    />
                    <ChoiceTile
                      clicked={this.state.english}
                      onClick={this.toggleOptionTwo}
                      title="English"
                      key={"English"+this.state.english}
                    />
                  </div>
                  <EnterButton title="Next" onClick={this.executeNextStep} />
                </div>
              </div>
            </div>
          </CSSTransition>
        <Navigation progress={70} history={this.props.history} />
      </div>
    )
  }
}
